import React, { FunctionComponent } from 'react'
import Transferir from '../components/Transferir'
import ContainerPage from '../../../../shared/components/ContainerPage'
import { IComprovanteTransferencia } from '../../domain/usecases/ComprovanteTransferencia'
import { IGetCartoes } from '../../domain/usecases/GetCartoes'
import { IVerifyPassword } from '../../domain/usecases/VerifyPassword'
import CartaoNew from '../components/CartaoNew'

interface TransferenciaProp {
  comprovanteTransferencia: IComprovanteTransferencia
  getCartao: IGetCartoes
  verifyPassword: IVerifyPassword
}
const Transferencia: FunctionComponent<TransferenciaProp> = ({
  getCartao,
  comprovanteTransferencia,
}) => {
  return (
    <ContainerPage
      breadCrumb="Pagamentos/Transferência"
      showScaffold={false}
      showFooterScaffold={false}
      header={<CartaoNew />}
    >
      <Transferir />
    </ContainerPage>
  )
}

export default Transferencia
